/**
 * Created by Ning Jiang on 2021-06-17.
 */

import {gsap, TimelineLite} from "gsap";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class BitmapCountUp extends PIXI.BitmapText {

    private _originalFontSize:number;
    private _isResizeDirty:boolean = false;

    public shrinkSize:boolean;
    public currentValue:number;
    public evenCharWidth:boolean = true;

    public onEnd:(() => void) | null;

    private _maxTextWidth:number = 720;
    get maxTextWidth():number {
        return this._maxTextWidth;
    }

    set maxTextWidth(value:number) {
        this._maxTextWidth = value;
        if(this.parent) {
            this.updateCountUpTextPivot();
        } else {
            this._isResizeDirty = true;
        }
    }

    // @ts-ignore - this is declared as a property in pixi ts definitions. But it is in fact accessors and should be overridable like this. But Typescript 5 complains
    get width():number {
        return this.textWidth;
    }

    constructor(style:BitmapTextStyleOptions) {
        super("", style);
        this._originalFontSize = style.fontSize!;
        this._isResizeDirty = true;
        this.on("added", this.onAdded);
    }

    private onAdded():void {
        if(this._isResizeDirty) {
            this.updateCountUpTextPivot();
        }
    }

    public getCountUpAnimation(fromValue:number, toValue:number, duration:number, ease:string = "none"):TimelineLite {
        const tl:any = gsap.timeline?.();
        tl.add(
            gsap.fromTo?.(this,
                {currentValue : fromValue},
                {
                    duration : duration,
                    currentValue : toValue,
                    ease : ease,
                    onStart : () => {
                        if(this.shrinkSize) {
                            this.fontSize = this._originalFontSize;
                            //this.updateText(); // removed in PIXI v5
                        }
                        this.onCountUpUpdate(toValue);
                        this.updateCountUpTextPivot();
                    },
                    onUpdate : () => this.onCountUpUpdate(toValue),
                    onComplete : () => {
                        this.onCountUpUpdate(toValue);
                    }
                })
        );

        return tl;
    }

    private onCountUpUpdate(toValue:number):void {
        const lastStringLength:number = this.text.length;
        this.text = SlotGame.apiPlugin.currency.formatValue(this.currentValue);
        if(!this.evenCharWidth || lastStringLength != this.text.length) {
            this.updateCountUpTextPivot();
        }
        if(this.currentValue >= (toValue - 0.01) && this.onEnd) {
            this.onEnd();
            this.onEnd = null;
        }
    }

    private updateCountUpTextPivot():void {
        if(!this.parent) {
            this._isResizeDirty = true;
            return;
        }

        this.dirty = true;
        this.updateTransform(); //Force update transform so that the textWidth are updated.
        if(this.shrinkSize) {
            while(this.textWidth > this._maxTextWidth) {
                this.fontSize--;
                this.dirty = true;
                this.updateTransform();
            }
        }
        this.pivot.set(this.textWidth * 0.5, this.textHeight * 0.5);
        this._isResizeDirty = false;
    }
}